// pages/Services.js
import React from "react";
import Header from "../components/home/Header";
import OurWorkSection from "../components/ourwork/OurWork";
import Footer from "../components/home/Footer";

function ServicesPage() {
  return (
    <div>
      <Header />
      <OurWorkSection />
      <Footer />
    </div>
  );
}

export default ServicesPage;
